module.exports = __webpack_public_path__ + "revicons.1142a254da20b59e7d10.svg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/revolution/fonts/revicons/revicons.svg?5510888
// module id = ../../../../../src/assets/revolution/fonts/revicons/revicons.svg?5510888
// module chunks = styles